/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Tabs } from "antd";
// import Heading from "../../../components/Heading";
// import OnboardHub from "./CreateHubOnboard";
// import ViewHub from "./ListHubOnboard";
// import "./style.scss";
import Heading from "../../../components/Heading";
import LeadClientOnboardingSteps from "./LeadClientOnboardingSteps";
import useCustomNavigate from "../../../components/customNavigationHook";
// import ViewClientTable from "./viewClientTable";

const LeadClientOnboarding = () => {
  // const navigate = useCustomNavigate();navigate = useCustomNavigate();;
  const [activeKey, setActiveKey] = useState("1");
  // const [check, setCheck] = useState(false);

  // const changeTab = (key) => {
  //   setActiveKey(key);
  //   setCheck(!check);
  //   if (key === "2") {
  //     navigate("/client-list");
  //   }
  // };

  return (
    <div className="p-2">
      <Heading title="Lead Client Onboarding" />
      <div className="master-main-container m-1">
        <LeadClientOnboardingSteps />
      </div>
    </div>
  );
};

export default LeadClientOnboarding;
